import { QueryClient } from '@tanstack/react-query';

/**
 * The till's one QueryClient. Shared from here (rather than created inside
 * main.tsx) so code outside React — the cart store loading an edited invoice —
 * can read the catalog the till already holds, instead of fetching it again.
 */
export const appQueryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 30_000,
    },
  },
});
